import { GET,} from "../../helper/collaticaRestFunctions";

export const getOrgUserRoles = async (org_id: any) => {
  const path = `/orgs/${org_id}/roles`;
  return await GET(path)
    .then((result) => {
      return result[1];
    })
    .catch((err) => {
      console.log("error on fetching users > ", err);
      return err;
    });
};
